// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Ghbi","left":"InfoRow_left__GvFCm"};